import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const useDeleteCustomSafe = () => {
  const { invalidateQuery: invalidateViewQueries } = useInvalidateQueries(
    QueryKey.GET_SCENARIO_CUSTOM_SAFES,
  );

  const { invalidateQuery: invalidateCalculationQueries } = useInvalidateQueries(
    QueryKey.GET_CONVERSION_SUMMARY,
    QueryKey.CALC_CUSTOM_SAFE,
    QueryKey.CALC_SCENARIO_SAFES,
    QueryKey.CALC_SCENARIO_INVESTMENT,
  );

  const { mutate: deleteCustomSafe, isPending } = useAppMutation(
    [QueryKey.DELETE_SCENARIO_CUSTOM_SAFE],
    {
      mutationFn: ({ scenarioId, safeId }: { safeId: string; scenarioId: string }) =>
        ApiService.delete({
          endpoint: BackendRoute.SCENARIOS,
          routePath: [scenarioId, 'custom-safes', safeId],
        }),
      onSuccess: () => {
        invalidateCalculationQueries();
        invalidateViewQueries();
      },
    },
  );
  return { deleteCustomSafe, isPending };
};
